export default __webpack_public_path__ + "static/window-image-0217438a099eb509d656ca3c69adf1cf.png";